import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { IHotelItem } from '../../components/booking-hotel-card/booking-hotel-card.component';
import { WebApiService } from '../../../core/services/web-api.service';

@Injectable()
export class HotelsProviderServiceService {
  constructor(private readonly webApiService: WebApiService) {}

  public getHotelsCollection(
    cityId: string,
    dates = null,
    payload?: {},
  ): Observable<IHotelItem[]> {
    const f = {
      limit: 30,
      offset: 0,
      ...payload,
    };
    return this.webApiService.post(`hotels/searchCity/${cityId}`, f).pipe(
      map((r) => {
        if (r && r.results) {
          const arr = r.results;
          arr.forEach((i: any) => {
            i.rating.average = i.rating.average?.toFixed(1);
            i.image = i.image[0];
          });
          return arr;
        }

        return [];
      }),
    );
  }
}
